import React from 'react';
import { Loader2, Zap, Eraser } from 'lucide-react';

/**
 * "Seed" tab body of the Demo Toolkit. Trigger / clear synthetic anomalies
 * during a demo. Pure UI — handlers come from the parent.
 */
export default function DemoSeedTab({ busy, triggerAnomaly, clearLiveAnomalies }) {
  return (
    <>
      <button
        onClick={triggerAnomaly}
        disabled={busy === 'trigger'}
        className="flex items-center gap-2.5 rounded-lg px-3 py-2 text-xs font-medium text-slate-700 transition-colors hover:bg-indigo-50 hover:text-indigo-700 disabled:opacity-60"
        data-testid="toolkit-trigger-anomaly-btn"
      >
        {busy === 'trigger' ? (
          <Loader2 className="h-4 w-4 animate-spin text-indigo-500" />
        ) : (
          <Zap className="h-4 w-4 text-indigo-500" />
        )}
        <span>Trigger anomaly</span>
      </button>
      <button
        onClick={clearLiveAnomalies}
        disabled={busy === 'clear-anom'}
        className="flex items-center gap-2.5 rounded-lg px-3 py-2 text-xs font-medium text-slate-700 transition-colors hover:bg-slate-100 hover:text-slate-900 disabled:opacity-60"
        data-testid="toolkit-clear-anomalies-btn"
        title="Remove every trigger-button anomaly (keeps the 5 seeded narrative events)"
      >
        {busy === 'clear-anom' ? (
          <Loader2 className="h-4 w-4 animate-spin text-slate-500" />
        ) : (
          <Eraser className="h-4 w-4 text-slate-500" />
        )}
        <span>Clear live anomalies</span>
      </button>
    </>
  );
}
